import { render, staticRenderFns } from "./BasketEstablishment.vue?vue&type=template&id=33965ba5"
import script from "./BasketEstablishment.vue?vue&type=script&lang=js"
export * from "./BasketEstablishment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports